export enum FieldTableActionTypes {
  SET_TABLE_DATA,
  SET_PREVIOUS_TABLE_DATA
}
